var o = "object" == typeof document && document.all,
  d = {
    all: o,
    IS_HTMLDDA: void 0 === o && void 0 !== o
  };
export { d };